import Color from '@/Enums/Color.enum';
import type { IProduct } from '@/Interfaces/Product.interface';
import { getProductInventoryHint } from '@/helpers/productInventory';
import classNames from 'classnames';

interface IProps extends Pick<IProduct, 'name' | 'publishers' | 'domainsCount'> {
  checked?: boolean;
}

const PackageItem = ({ checked, name, publishers, domainsCount }: IProps) => (
  <div
    className={classNames(
      'w-full text-start px-3 py-1 rounded-md font-[Manrope] text-[16px] text-[#303030] focus:outline-none',
      { 'bg-[#1b43321f]': checked },
    )}
  >
    <span className='flex items-center justify-between gap-3'>
      <span className='truncate'>{name}</span>
      <span className={`shrink-0 text-[13px] text-[${Color.Grey}]`}>
        {getProductInventoryHint({ publishers, domainsCount })}
      </span>
    </span>
  </div>
);

export default PackageItem;
